import type { Element } from 'slate';

import { Editor, Point, Range } from 'slate';
import { ReactEditor, useSelected } from 'slate-react';

export const useIsWholeBlockSelected = (editor: Editor, element: Element) => {
  const selected = useSelected();
  if (!selected || !editor.selection) return false;

  const path = ReactEditor.findPath(editor, element);
  const elementRange = Editor.range(editor, path);

  return (
    Point.compare(Range.start(elementRange), Range.start(editor.selection)) >= 0 &&
    Point.compare(Range.end(elementRange), Range.end(editor.selection)) <= 0
  );
};
